module.exports = "https://static.energy5.com/_next/static/images/ourMissionImage-5e31e06921ac9c85d8e1f60402bc4f83.jpg";